import React from 'react';
import { Box, Span } from '../element';
import { NavLink } from '../link';
import Strings from '../../locales/Strings';

const SideBarItem = props => {
  const { border, index, item, queryString, active } = props;
  const activeClass = active ? 'active' : '';
  return (
    <Box justify="start" border={border} fill={true} className="autoMinHeight">
      <NavLink
        className={'leftNavMenu ' + activeClass}
        to={item.path + queryString}
        data-test-id={`sidebar-${item.menuText}-link`}>
        <Span className="paddingRight3">{index + 1}</Span>
        {Strings[item.menuText]}
      </NavLink>
      {/* todo */}
      {/* <Route path="/physicalInstall" url="/physicalInstall" component={PhysicalInstallSteps} /> */}
    </Box>
  );
};

export default SideBarItem;
